import {ETreeColDataType, ETreeColFilterType, ETreeColType, TreeColDef} from './tree-col-def';

export class TreeColDefCache {
    public iID?: number;
    public index?: number;
    public treeColDef?: TreeColDef;

    public wrapperClassList?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public booleanLabelStyleCache?: (Record<string, any> | undefined)[];

    // ===============================================================
    // ===============================================================

    public _init(iID: number, tableColDefs: TreeColDef[], treeColDef: TreeColDef) {
        this.initTreeColDef(treeColDef);

        this.iID = iID;
        this.index = tableColDefs.indexOf(treeColDef);
        this.treeColDef = treeColDef;

        if (treeColDef.fnOnCellClick) {
            this.wrapperClassList = 'pointer text-decoration-underline';
        } else {
            this.wrapperClassList = '';
        }

        switch (this.treeColDef.dataType) {
            case ETreeColDataType.BOOLEAN_ICON:
            case ETreeColDataType.BOOLEAN_ICON_INV:
            case ETreeColDataType.BOOLEAN_LABEL:
            case ETreeColDataType.TAGS:
            case ETreeColDataType.CHIPS:
            case ETreeColDataType.DATE:
                break;
        }

        if (treeColDef.dataType === ETreeColDataType.BOOLEAN_LABEL) {
            this.booleanLabelStyleCache = [
                treeColDef.tags?.find((opt) => !opt.value)?.style ?? undefined,
                treeColDef.tags?.find((opt) => !!opt.value)?.style ?? undefined
            ];
        }
    }

    private initTreeColDef(tableColDef: TreeColDef) {
        if (tableColDef.type === undefined) tableColDef.type = ETreeColType.DATA;
        if (tableColDef.dataType === undefined) tableColDef.dataType = ETreeColDataType.TEXT;
        if (tableColDef.searcheable === undefined) tableColDef.searcheable = true;
        if (tableColDef.sortable === undefined) tableColDef.sortable = true;
        if (tableColDef.filterable === undefined) tableColDef.filterable = true;
        if (tableColDef.filterType === undefined) tableColDef.filterType = ETreeColFilterType.TEXT;
    }
}
